<template>
    <div class="min-h-screen flex flex-col">
        <div class="container mx-auto p-2 mt-8">
            <div class="max-w-sm w-full mx-auto bg-white px-5 py-10 shadow-md rounded-lg">
                <div class="text-center mb-6">
                    <div class="text-xl font-bold text-gray-800 mb-1">Configurar 2FA</div>
                    <div class="text-xs text-gray-400">Escaneie o QR code com Google Authenticator ou Authy</div>
                </div>

                <div v-if="loading" class="text-center text-gray-400 py-8 text-sm">Gerando QR code...</div>

                <div v-else-if="qrCode">
                    <div class="border border-gray-200 rounded-lg p-3 w-fit mx-auto mb-4">
                        <img :src="qrCode" alt="QR Code TOTP" class="w-48 h-48" />
                    </div>
                    <p class="text-xs text-gray-400 text-center mb-5">
                        Após escanear, insira o código de 6 dígitos para confirmar.
                    </p>

                    <form @submit.prevent="confirmSetup">
                        <input
                            ref="totpInput"
                            v-model="totpCode"
                            type="text"
                            inputmode="numeric"
                            maxlength="6"
                            placeholder="000000"
                            class="input input-bordered w-full text-sm text-center tracking-widest font-mono mb-3"
                        />
                        <p v-if="error" class="text-red-600 text-xs mb-3 text-center">{{ error }}</p>
                        <button type="submit" class="w-full btn btn-primary text-white" :disabled="confirming">
                            <span v-if="confirming" class="loading loading-spinner loading-sm"></span>
                            <span v-else>Confirmar e Entrar</span>
                        </button>
                    </form>
                </div>

                <div v-else class="text-center text-red-600 text-sm py-8">
                    Erro ao gerar QR code. <router-link :to="loginRoute" class="text-cyan-600 underline">Voltar</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import AdminAuthService from '@/services/admin/AdminAuthService';

export default {
    name: 'AdminSetup',
    setup() {
        const router = useRouter();
        const route = useRoute();
        const email = computed(() => route.query.email || '');
        const qrCode = ref('');
        const totpCode = ref('');
        const loading = ref(true);
        const confirming = ref(false);
        const error = ref('');
        const totpInput = ref(null);

        const loginRoute = computed(() => ({ name: 'adminLogin', params: { uuid: route.params.uuid } }));

        onMounted(async () => {
            if (!email.value) {
                router.push(loginRoute.value);
                return;
            }
            try {
                const { data } = await AdminAuthService.init(email.value);
                if (!data.needsSetup) {
                    router.push({ name: 'adminLogin', params: { uuid: route.params.uuid } });
                    return;
                }
                qrCode.value = data.qrCodeDataUrl;
                await nextTick();
                totpInput.value?.focus();
            } catch {
                qrCode.value = '';
            } finally {
                loading.value = false;
            }
        });

        async function confirmSetup() {
            if (totpCode.value.length !== 6) { error.value = 'Código deve ter 6 dígitos'; return; }
            error.value = '';
            confirming.value = true;
            try {
                const { data } = await AdminAuthService.setup(email.value, totpCode.value);
                AdminAuthService.saveToken(data.token);
                router.push({ name: 'adminDashboard', params: { uuid: route.params.uuid } });
            } catch (err) {
                error.value = err.response?.data?.text || 'Código inválido';
                totpCode.value = '';
            } finally {
                confirming.value = false;
            }
        }

        return { email, qrCode, totpCode, loading, confirming, error, totpInput, loginRoute, confirmSetup };
    }
};
</script>
